import {IAction} from "../IAction";
import {cloneDeep} from "lodash";
import InitialRttrStore, {IRttrStore} from "./InitialRttrStore";
import {RealmHandoffPayload} from "./rttrActions";

export enum RttrAction {
    SET_REALM_HANDOFF = "SET_REALM_HANDOFF",
    CLEAR_REALM_HANDOFF = "CLEAR_REALM_HANDOFF",
}

export default function rttrReducer(store: IRttrStore = InitialRttrStore, a: IAction<RttrAction, any>): IRttrStore {
    const n: IRttrStore = cloneDeep(store);

    switch (a.type) {
        case RttrAction.SET_REALM_HANDOFF: {
            const payload = a.payload as RealmHandoffPayload;
            n.realmUuid = payload.realmUuid;
            n.realmTs = payload.realmTs;
            n.realmSig = payload.realmSig;
            n.realmHomeUrl = payload.realmHomeUrl;
            break;
        }
        case RttrAction.CLEAR_REALM_HANDOFF:
            n.realmUuid = undefined;
            n.realmTs = undefined;
            n.realmSig = undefined;
            n.realmHomeUrl = undefined;
            break;
        default:
            break;
    }

    return n;
}
